module.exports = __webpack_public_path__ + "assets/c03c32eb58c26dfe138f67ffdb71cfdd.mp3";